import { TextFieldCustomProps } from '~/components/atoms/inputs/TextField';
import { DropdownProps } from '~/components/molecules/Dropdown';
import { SelectDateRangeCustomProps } from '~/components/molecules/SelectDateRange';
import { REACTION } from '~/modules/reactions/types';

import { ToolType } from '../../types';

export enum FORM_FIELD_TYPES {
  TEXTAREA = 'textarea',
  SELECT = 'select',
  SELECT_DATE_RANGE = 'select_date_range',
}

export enum FormFields {
  TASK = 'task',
  PUBLICATION_YEARS = 'publication_years',
  REPORT_LANGUAGE = 'language',
  REPORT_TYPE = 'report_type',
}

type DateRangeType = {
  startYear: number;
  endYear: number;
};

export type AiResearcherFormDataType = {
  [FormFields.TASK]: string;
  [FormFields.REPORT_LANGUAGE]: string;
  [FormFields.REPORT_TYPE]: string;
  [FormFields.PUBLICATION_YEARS]: DateRangeType;
};

export type AiResearcherItemType = {
  id: string;
  task: string;
  output: string;
  reaction: REACTION;
  pdf_link: string;
  demo_mode?: boolean;
  ai_model: string;
};

export type ExtendedAiResearcherItem = AiResearcherItemType & {
  is_in_progress: boolean;
};

type BaseUiFieldType = {
  $ref?: { field: string; value: string | number | boolean }[];
  title: string;
};

type SelectUiFieldType = BaseUiFieldType & {
  type: FORM_FIELD_TYPES.SELECT;
  props: Omit<DropdownProps, 'options'> & {
    options: {
      value: string;
      text: string;
      disabled?: boolean;
      tooltip?: string;
    }[];
    required: boolean;
  };
};

type TextareaUiFieldType = BaseUiFieldType & {
  type: FORM_FIELD_TYPES.TEXTAREA;
  props: TextFieldCustomProps & {
    required: boolean;
  };
};

type SelectDateRangeUiFieldType = BaseUiFieldType & {
  type: FORM_FIELD_TYPES.SELECT_DATE_RANGE;
  props: SelectDateRangeCustomProps & {
    required: boolean;
  };
};

export type ResearcherUiFieldType =
  | SelectUiFieldType
  | TextareaUiFieldType
  | SelectDateRangeUiFieldType;

export type ResearcherToolType = ToolType & {
  validation_schema: Record<string, any>;
  ui_schema: Record<string, ResearcherUiFieldType>;
  last_inputs: Record<string, ResearcherUiFieldType['props']['value']>;
};
